import { useState, useEffect } from "react";
import { inject, observer } from "mobx-react";

import { Card } from "primereact/card";
import { RadioButton } from "primereact/radiobutton";

import ActivateFileCode from "./ActivateFileCode";
import ActivateFlexible from "./ActivateFlexible";
import ActivateFileActivation from "./ActivateFileActivation";
import { Accordion, AccordionTab } from "primereact/accordion";

import "./style.scss";
import Formatter from "./Formatter";

const ActivatePage = inject("mainStore")(
    observer(({ mainStore }) => {
        const [selectedCategory, setSelectedCategory] = useState(dataRadioButton[0]);
        const [vendors, setVendors] = useState([]);
        const [rates, setRates] = useState([]);
        const [offer, setOffer] = useState([]);
        const [sites, setSites] = useState([]);
        const [value, setValue] = useState(true);
        const [openAccordion, setOpenAccordion] = useState(true);

        useEffect(() => {
            getVendors();
            getRates();
            getOffer();
            getSite();
        }, []);

        const getVendors = async () => {
            const resp = await mainStore.getByUrl("/promo/suggest_list?collection=vendors&sortField=name&sortOrder=asc", false, "", false, false);
            if (resp && resp.success) {
                setVendors(resp.data.filter((el) => el.active));
            }
        };

        const getRates = async () => {
            const resp = await mainStore.getByUrl("/promo/suggest_list?collection=rates", false, "", false, false);
            if (resp && resp.success) {
                setRates(resp.data);
            }
        };

        const getOffer = async () => {
            const resp = await mainStore.getByUrl(
                "/promo/suggest_list?collection=offers&project[title]=1&project[technicalName]=1&project[_id]=1&project[vendorId]=1&project[rateIds]=1&project[code]=1&project[active]=1&project[dateStart]=1&project[dateEnd]=1&project[draft]=1&sortField=name&sortOrder=asc",
                false,
                "",
                false,
                false,
            );
            if (resp && resp.success) {
                setOffer(resp.data);
            }
        };

        const getSite = async () => {
            const resp = await mainStore.getByUrl("/promo/suggest_list?collection=sites&project[_id]=1&project[code]=1&project[name]=1&project[archived]=1&sortField=name&sortOrder=asc&filters[active]=true", false, "", false, false);
            if (resp && resp.success) {
                setSites(resp.data);
            }
        };

        let Specified = pages[selectedCategory.key] ? pages[selectedCategory.key] : pages["file"];

        const renderTitle = (item) => {
            const titleText = "Ввод активаций / ";
            return (
                <span>
                    {titleText}
                    {item && <span style={{ color: "#495057", fontWeight: 400 }}>{item}</span>}
                </span>
            );
        };

        return (
            <div className="activate">
                <Card className="activate__block" title={() => renderTitle(selectedCategory.name)}>
                    <label className="button__radio-label">Выберите опции активаций </label>
                    <Accordion onTabClose={() => setOpenAccordion((prev) => !prev)} onTabOpen={() => setOpenAccordion((prev) => !prev)} className="activate__faq">
                        <AccordionTab
                            key={selectedCategory.key}
                            header={
                                <div className="accordion__header">
                                    <i className="pi pi-exclamation-circle"></i>
                                    <span className="accordion__header-title">{selectedCategory.accordionHeader}</span>
                                    {openAccordion ? <span>{selectedCategory.name}</span> : null}
                                </div>
                            }
                        >
                            {selectedCategory.accordionDesc}
                        </AccordionTab>
                    </Accordion>
                    <div className="button__radio">
                        {dataRadioButton.map((category) => {
                            return (
                                <div key={category.key} className="radio">
                                    <RadioButton
                                        inputId={category.key}
                                        name="category"
                                        value={category}
                                        onChange={(e) => {
                                            setSelectedCategory(e.value);
                                            setValue(true);
                                        }}
                                        checked={selectedCategory.key === category.key}
                                    />
                                    <label htmlFor={category.key} className="radio-label">
                                        {category.name}
                                    </label>
                                </div>
                            );
                        })}
                    </div>

                    <div className="content">
                        {selectedCategory.key !== "file" ? (
                            <div className="button__group">
                                {buttonSelect.map((m, idx) => {
                                    return (
                                        <div key={idx} className={`button__group_item ${value === m.value ? "active" : ""}`} onClick={() => setValue(m.value)}>
                                            {m.name}
                                        </div>
                                    );
                                })}
                            </div>
                        ) : null}
                        {value && selectedCategory.key !== "file" ? (
                            <div className="onboarding">
                                <i className="pi pi-exclamation-triangle"></i>
                                <div>
                                    <span style={{ fontWeight: "600", marginRight: "7px" }}>Внимание</span>
                                    <span>Вы на вкладке «Замена данных». Укажите новые данные активаций, загруженные ранее!</span>
                                </div>
                            </div>
                        ) : null}
                        <Specified vendors={vendors} rates={rates} offer={offer} sites={sites} tabItems={tabItems} forceSet={value} />
                    </div>
                    <Formatter />
                </Card>
            </div>
        );
    }),
);

const pages = {
    file: ActivateFileCode,
    flexible: ActivateFlexible,
    activation: ActivateFileActivation,
    // range: ActivateRange,
    // revenue: ActivateRevenue
};

const tabItems = [
    { label: "Руб. за заказ", key: "rubPerOrder" },
    { label: "Градация ставок", key: "rateGradation" },
    { label: "% от суммы заказа", key: "percentAmount" },
];

const dataRadioButton = [
    {
        name: "Загрузка файла с кодами",
        key: "file",
        accordionHeader: "Что значит это тип активации?",
        accordionDesc: (
            <div>
                <ol>
                    <li>
                        <span>Назначение: </span>Функционал предназначен для импорта данных об активациях промокодов, предоставляемых партнёрами, посредством загрузки CSV-файла.
                    </li>
                    <li>
                        <span>Формат файла:</span> Файл должен иметь формат CSV и должен быть вида: Промокод - Дата активации - Ставка (С НДС)
                    </li>
                    <li>
                        <span>Дополнительно:</span> При загрузке файла пользователь может указать, что файл не содержит дату активации и/или ставку. В этом случае система использует выбранные настройки для корректной обработки данных.
                    </li>
                    <li>
                        <span>После загрузки система сохраняет данные в базу в следующей разбивке:</span> Оффер – Сайт – Кол-во активаций – День - Выручка
                        <br />
                        <span>Кроме того, формируется сводная (аккумулирующая) запись вида:</span> Оффер – Кол-во активаций – День - Выручка
                    </li>
                </ol>
            </div>
        ),
    },
    {
        name: "Гибкая активация",
        key: "flexible",
        accordionHeader: "Что значит это тип активации?",
        accordionDesc: (
            <div>
                <ol>
                    <li>
                        <span>Назначение: </span>Функционал предназначен для учёта активаций партнёров, которые работают без уникальных промокодов — например, по партнёрской ссылке или с единым промокодом.
                    </li>
                    <li>
                        <span>Дополнительно:</span> Для загрузки активаций необходимо заполнить обязательные поля, и нажать кнопку отправить
                    </li>
                    <li>
                        <span>Перед сохранением пользователь выбирает тип загрузки:</span>
                        <br />
                        <span>Загрузка новых активаций:</span> Новые данные добавляются к уже существующим записям. Количество активаций суммируется с предыдущими значениями.
                        <br />
                        <span>Замена данных:</span> Данные за выбранный период полностью удаляются, и вместо них записываются новые значения.
                    </li>

                    <li>
                        <span>После отправки формы система сохраняет данные в базу в следующей разбивке:</span>
                        <br />
                        Оффер – Сайт – Кол-во активаций – День - Выручка
                        <br />
                        <span>Кроме того, формируется сводная (аккумулирующая) запись вида:</span>
                        <br /> Оффер – Кол-во активаций – День - Выручка
                    </li>
                </ol>
            </div>
        ),
    },
    {
        name: "Загрузка файла с активациями",
        key: "activation",
        accordionHeader: "Что значит это тип активации?",
        accordionDesc: (
            <div>
                <ol>
                    <li>
                        <span>Назначение: </span>Функционал предназначен для импорта агрегированных данных об активациях по дням, предоставляемых партнёрами в виде CSV-файла. Используется для автоматического обновления статистики без необходимости
                        загружать отдельные промокоды.
                    </li>
                    <li>
                        <span>Файл должен иметь формат CSV и содержать следующие колонки: </span> Дата активаци - Id офферы - колличество - Ставка
                    </li>
                    <li>
                        <span>Принцип работы:</span>
                        После загрузки файла система обрабатывает его и сохраняет данные в базу.
                        <br />
                        В отличие от гибкой активации, при этом создаются только сводные (аккумулирующие) записи, без детализации по сайтам:
                        <br />
                    </li>

                    <li>
                        <span>Формат записи в базе:</span>
                        <br />
                        Оффер – Кол-во активаций – День - Выручка
                    </li>
                </ol>
            </div>
        ),
    },
];

const buttonSelect = [
    { name: "Загрузка новых активаций", value: false },
    { name: "Замена данных", value: true },
];
export default ActivatePage;
